import type { PricingQuoteResponse, ProductCard } from "@itaas/pep-contracts";
import type { PepLocale } from "../../i18n/types";
import { MINEPORTAL_HD_CONFIG } from "./mineportal-detail-content";
import { ProductDetailHdPage } from "./ProductDetailHdPage";

export interface MineportalProductDetailHdProps {
  locale: PepLocale;
  product: ProductCard & { complementary?: ProductCard[] };
  prices: Record<string, PricingQuoteResponse>;
  description: string;
  showDemo: boolean;
  showTrial: boolean;
}

/** MinePortal HD — shared ProductDetailHdPage + mining hero assets. */
export function MineportalProductDetailHd(props: MineportalProductDetailHdProps) {
  return <ProductDetailHdPage {...props} config={MINEPORTAL_HD_CONFIG} />;
}
